import { createSlice } from '@reduxjs/toolkit';
import { getMatrimonyTransactions } from '../../actions/Transaction/transactionMatrimonyActions';
import { actionTypes } from '../../actionTypes';
// redux state
const initialState = {
  transactionsMatrimony: undefined,
  error: '',
  isLoading: false,
};

// slice or reducer
const MatrimonyTransactions = createSlice({
  name: 'MatrimonyTransactions',
  initialState,
  // normal reducers
  reducers: {
    clearError(state) {
      state.error = undefined;
    },
  },
  // async reducers
  extraReducers: (builder) => {
    caseMatrimonyTransactions(builder, getMatrimonyTransactions);
  },
});
export default MatrimonyTransactions.reducer;

const caseMatrimonyTransactions = (builder, action) => {
  builder.addCase(action.pending, (state) => {
    state.isLoading = true;
  });
  handleAllFulfillCases(builder, action);

  builder.addCase(action.rejected, (state) => {
    state.isLoading = false;
  });
};

const handleAllFulfillCases = (builder, action) => {
  builder.addCase(action.fulfilled, (state, action) => {
    // state updated in fulfilled state

    if (action.type.includes(actionTypes.GET_MATRIMONY_TRANSACTION)) {
      state.isLoading = false;
      state.transactionsMatrimony = action.payload;
    }
  });
};
